/* eslint-disable */
import React, { useState, useEffect } from "react";


import {  useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
const InvitedEmailField = ({token, register, setError ,errors ,setValue}) => {
const { t } = useTranslation();
  const getUri = useLocation()
  const [isLoadingCheckToken, setIsLoadingCheckToken] = useState(false)
  const [emailInvitation, setEmailInvitation] = useState("")

  const checkToken = async () => {
    const cleanedPath = getUri.pathname.slice(1);

    if (!cleanedPath) return
       setIsLoadingCheckToken(true)

    try {


      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/email-invitaion/`,
        {
          params: {
            type: cleanedPath,
            token: token,
          },
        }
      );


     
setValue("email", response.data['email']);
      setEmailInvitation(response.data['email'])


    } catch (error) {
  const message =
  error?.response?.data?.error || 
  error?.message ||               
  "An unexpected error occurred"; 
         setError("email", {
  type: "manual",
  message:message
});

    } finally {
      setIsLoadingCheckToken(false)
    }

  }
  useEffect(() => {

    token && checkToken()
  }, [])
  return (
   <div className="input-block mb-3">
                    <label className="form-control-label">{t("Email")}</label>

                    <div style={{ position: 'relative' }}>
                      <input
                        className="form-control"
                        type="text"
                     autoComplete="off"
                        disabled={token}
                        {...register("email")}
                        style={{ paddingRight: '2rem' }} // room for spinner
                      />
                      {isLoadingCheckToken && (
                        <div style={{
                          position: 'absolute',
                          right: '10px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                        }}>
                          <div className="spinner-border spinner-border-sm text-primary" role="status">
                            <span className="visually-hidden">{t("Loading...")}</span>
                          </div>
                        </div>
                      )}
                    </div>
                    <p className="text-danger">{errors.email?.message}</p>
                  </div>
  );
};
export default InvitedEmailField;
